document.querySelectorAll('.cards-grid').forEach((wrap) => {
  const loadMoreButton = wrap.querySelector('.cards-grid__button .button');
  let currentItems = 12;
  const loadMore = () => {
    const elementList = [...wrap.querySelectorAll('.cards-grid__item')];
    if (!elementList) return;
    for (let i = currentItems; i < currentItems + 6; i += 1) {
      if (elementList[i]) {
        elementList[i].style.display = 'block';
      }
    }
    currentItems += 12;
    if (currentItems >= elementList.length) {
      loadMoreButton.style.display = 'none';
    }
  };

  if (loadMoreButton) loadMoreButton.addEventListener('click', loadMore);
});

const ADD_CLASS=1;
const REMOVE_CLASS=0;

function AddOrRemoveClassSliderOnSmallScreen(withSliderAddClass,withoutSliderAddClass,AddOrRemove ) {
  if(window.innerWidth < 1100){
    const withoutSliderElementsList=document.getElementsByClassName("withoutslider");
    const sliderWithNextSlideElementsList=document.getElementsByClassName("slider--single--with--next-slide-view");

    if(withoutSliderElementsList.length > 0 && sliderWithNextSlideElementsList.length > 0){
      if(AddOrRemove == ADD_CLASS){
        sliderWithNextSlideElementsList[0].classList.add(withSliderAddClass);
        withoutSliderElementsList[0].classList.add(withoutSliderAddClass);
      }else if(AddOrRemove == REMOVE_CLASS){
        sliderWithNextSlideElementsList[0].classList.remove(withSliderAddClass);
        withoutSliderElementsList[0].classList.remove(withoutSliderAddClass);
      }
      const splidePaginationElementsList=document.getElementsByClassName("splide__pagination");
      if(splidePaginationElementsList.length > 0 ){
        splidePaginationElementsList[0].classList.add('d-flex');
      }
    }
  }
}


const tabs = document.querySelectorAll('.content-slider-tabs');
if(tabs.length > 0){
  tabs[0].classList.add('active-tab');
}

AddOrRemoveClassSliderOnSmallScreen('d-none','d-block',ADD_CLASS);

tabs.forEach(clickedTab =>{
  clickedTab.addEventListener('click', (e) => {
    tabs.forEach( tab => {
      tab.classList.remove('active-tab');
    });
    e.currentTarget.classList.add('active-tab');

    var activeTab=e.currentTarget;
    
    if(activeTab != tabs[1] ){
      cardsLabel=document.querySelectorAll(".card-label");
      cardsLabel.forEach(card =>{
        card.style.display = "none";
      });

      document.getElementById("tabs-steps").style.display = "none";
      
      AddOrRemoveClassSliderOnSmallScreen('d-none','d-block',ADD_CLASS);

    }else {
      cardsLabel=document.querySelectorAll(".card-label");
      cardsLabel.forEach(card =>{
        card.style.display = "inline-block";
      });
      document.getElementById("tabs-steps").style.display = "flex";

      AddOrRemoveClassSliderOnSmallScreen('d-none','d-block',REMOVE_CLASS);
    }
      
  });
});






const resizeGridFunction=()=>
    {
      if(tabs.length >= 2){
        if(window.innerWidth <= 1100){
            tabs[0].innerHTML="Ja";
            tabs[1].innerHTML="Nein";
        }
        else{
            tabs[0].innerHTML="Ja, ich habe einen Pflegegrad";
            tabs[1].innerHTML="Nein, ich habe keinen Pflegegrad";
        }
      }
       
    };
resizeGridFunction();
addEventListener("resize", (event) => {});

onresize = (event) => {
    resizeGridFunction();
};
    